// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.explore-page-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    background-color: rgb(16, 16, 17);
    overflow-x: hidden;
    position: relative;
    color: rgba(255, 255, 255, 0.8);
    font-size: 16px;
}

@keyframes fadein {
    0% {
        opacity: 25%;
    }
    100% {
        opacity: 1;
    }
}
/* Hover info/widget, shown on hovering over an image */
.ehw-container {
    display: flex;
    flex-direction: column;
    z-index: 800;
    color: black;
    font-size: 14px;
    font-weight: 500;
    box-shadow: 0 0 15px 10px #0005;
    width: 90%;
    height: 90%;
    border-radius: min(15px, 3%);
    overflow: hidden;
    transition: transform 0.4s cubic-bezier( 0.24, 0.32, 0.03, 1 ) ;
    animation: fadein 0.2s ease-in-out;
}
.ehw-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    flex-wrap: nowrap;
    color: white;
    background-color: var(--primaryColorBright);
    background-image: var(--primaryColorGradient);
}
.ehw-profile-info-container {
    display: flex;
    align-items: center;
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.ehw-body {
    font-size: 18px;
    font-weight: 600;
    height: 100%;
    flex-grow: 1;
    box-sizing: border-box;
    color: #000;
    overflow-y: auto;
    background-color: #fff;
    display: flex;
    flex-direction: column;
}
.ehw-body p {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
    padding: 0;
    font-size: inherit;
}
.ehw-postText {
    margin: 0;
    padding: 0;
    font-weight: 600;
    word-wrap: break-word;
}
.ehw-timestamp {
    color: #0006;
    margin: 0;
    padding: 0;
    margin-top: 1em;
}
.ehw-nodesc {
    opacity: 0.5;
    font-style: italic;
}

/* pan & Grid */
.explore-page-pannable {
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    background-color: rgb(46, 46, 50);
    position: relative;
    overflow: hidden;
    cursor: grab;
}
.pan-wrapper {
    width: 100vw !important;
    height: calc(100vh - var(--menuBarHeight)) !important;
}
.exp-grid-overlay {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    cursor: pointer;
}

.ep-year-container {
    font-family: var(--displayFont);
    position: absolute;
    top: 0;
    left: 0;
    margin: var(--ec-scaledbutton) 0 0 var(--ec-scaledbutton);
    display: flex;
    gap: calc(var(--ec-scaledbutton) * 0.5);
    align-items: center;
    justify-content: center;
    z-index: 3;
    font-size: calc(var(--ec-scaledbutton) * 0.8);
    -webkit-user-select: none;
            user-select: none;
}
.ep-year-indicator {
    padding: calc(var(--ec-scaledbutton) * 0.4) calc(var(--ec-scaledbutton) * 1.5);
    font-size: calc(var(--ec-scaledbutton) * 0.8);
    font-weight: 600;
    font-family: var(--paragraphFont);
    border-radius: 1000px;
    color: white;
    z-index: 3;
    background-color: #0004;
    border: none;
    cursor: pointer;
    transition: box-shadow 0.2s;
}
.ep-year-indicator:hover {
    background-color: rgba(40, 56, 98, 0.533);
    box-shadow: 0 0 0 calc(var(--ec-scaledbutton) * 0.1) var(--primaryColorTransparent);
}
`, "",{"version":3,"sources":["webpack://./src/styles/explore/ExplorePage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,iCAAiC;IACjC,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI;QACI,YAAY;IAChB;IACA;QACI,UAAU;IACd;AACJ;AACA,uDAAuD;AACvD;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,UAAU;IACV,WAAW;IACX,4BAA4B;IAC5B,gBAAgB;IAChB,+DAA+D;IAC/D,kCAAkC;AACtC;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,YAAY;IACZ,2CAA2C;IAC3C,6CAA6C;AACjD;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,SAAS;IACT,UAAU;IACV,eAAe;AACnB;AACA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,uBAAuB;IACvB,qDAAqD;AACzD;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,yDAAyD;IACzD,aAAa;IACb,uCAAuC;IACvC,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,6CAA6C;IAC7C,yBAAiB;YAAjB,iBAAiB;AACrB;AACA;IACI,8EAA8E;IAC9E,6CAA6C;IAC7C,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;IACrB,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,2BAA2B;AAC/B;AACA;IACI,yCAAyC;IACzC,mFAAmF;AACvF","sourcesContent":[".explore-page-content {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    background-color: rgb(16, 16, 17);\n    overflow-x: hidden;\n    position: relative;\n    color: rgba(255, 255, 255, 0.8);\n    font-size: 16px;\n}\n\n@keyframes fadein {\n    0% {\n        opacity: 25%;\n    }\n    100% {\n        opacity: 1;\n    }\n}\n/* Hover info/widget, shown on hovering over an image */\n.ehw-container {\n    display: flex;\n    flex-direction: column;\n    z-index: 800;\n    color: black;\n    font-size: 14px;\n    font-weight: 500;\n    box-shadow: 0 0 15px 10px #0005;\n    width: 90%;\n    height: 90%;\n    border-radius: min(15px, 3%);\n    overflow: hidden;\n    transition: transform 0.4s cubic-bezier( 0.24, 0.32, 0.03, 1 ) ;\n    animation: fadein 0.2s ease-in-out;\n}\n.ehw-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 20px;\n    flex-wrap: nowrap;\n    color: white;\n    background-color: var(--primaryColorBright);\n    background-image: var(--primaryColorGradient);\n}\n.ehw-profile-info-container {\n    display: flex;\n    align-items: center;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.ehw-body {\n    font-size: 18px;\n    font-weight: 600;\n    height: 100%;\n    flex-grow: 1;\n    box-sizing: border-box;\n    color: #000;\n    overflow-y: auto;\n    background-color: #fff;\n    display: flex;\n    flex-direction: column;\n}\n.ehw-body p {\n    font-size: 18px;\n    font-weight: 600;\n    margin: 0;\n    padding: 0;\n    font-size: inherit;\n}\n.ehw-postText {\n    margin: 0;\n    padding: 0;\n    font-weight: 600;\n    word-wrap: break-word;\n}\n.ehw-timestamp {\n    color: #0006;\n    margin: 0;\n    padding: 0;\n    margin-top: 1em;\n}\n.ehw-nodesc {\n    opacity: 0.5;\n    font-style: italic;\n}\n\n/* pan & Grid */\n.explore-page-pannable {\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    background-color: rgb(46, 46, 50);\n    position: relative;\n    overflow: hidden;\n    cursor: grab;\n}\n.pan-wrapper {\n    width: 100vw !important;\n    height: calc(100vh - var(--menuBarHeight)) !important;\n}\n.exp-grid-overlay {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%,-50%);\n    cursor: pointer;\n}\n\n.ep-year-container {\n    font-family: var(--displayFont);\n    position: absolute;\n    top: 0;\n    left: 0;\n    margin: var(--ec-scaledbutton) 0 0 var(--ec-scaledbutton);\n    display: flex;\n    gap: calc(var(--ec-scaledbutton) * 0.5);\n    align-items: center;\n    justify-content: center;\n    z-index: 3;\n    font-size: calc(var(--ec-scaledbutton) * 0.8);\n    user-select: none;\n}\n.ep-year-indicator {\n    padding: calc(var(--ec-scaledbutton) * 0.4) calc(var(--ec-scaledbutton) * 1.5);\n    font-size: calc(var(--ec-scaledbutton) * 0.8);\n    font-weight: 600;\n    font-family: var(--paragraphFont);\n    border-radius: 1000px;\n    color: white;\n    z-index: 3;\n    background-color: #0004;\n    border: none;\n    cursor: pointer;\n    transition: box-shadow 0.2s;\n}\n.ep-year-indicator:hover {\n    background-color: rgba(40, 56, 98, 0.533);\n    box-shadow: 0 0 0 calc(var(--ec-scaledbutton) * 0.1) var(--primaryColorTransparent);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
